import { gql } from "@apollo/client";

export const MEMBER_BY_ID = gql`
  query MemberById($id: ObjectId!) {
    PathwaysMember(PathwaysMemberId: $id) {
      _id
      astranaId
      memberId
      memberPolicyId
      name
      dob
      gender
      healthplanCode
      lineOfBusiness
      ipaCode
      patientId
      sourceId
      enrollmentDate
      # Care Management market — the member's address state gates Care at Home
      # (CA/TX/RI only). See members/careManagementMarket.ts.
      address {
        state
      }
      # AC-TRX-1 — seeds the translator rail's patientLanguage. The field names
      # are care-management-gql's own: PathwaysMember exposes
      # languagePreferredSpoken / languagePreferred (see
      # graphql/type/objects/Pathways/Models/PathwaysMember.ts), NOT the
      # preferred_language spelling used elsewhere in the platform. (Keep this
      # comment backtick-free: the whole query is a tagged template literal, so
      # a backtick here closes it and breaks parsing.) Spoken is
      # what an interpreter needs; languagePreferred is the general fallback.
      # Free-text upstream, so both are normalized through
      # src/translator/patientLanguage.ts rather than used raw.
      languagePreferredSpoken
      languagePreferred
      memberIdOthers {
        mpi
        mbi
        apolloMemberKey
      }
    }
  }
`;

export interface MemberByIdVars { id: string }
export interface MemberByIdResult {
  PathwaysMember: {
    _id: string;
    astranaId?: string;
    memberId?: string;
    memberPolicyId?: string;
    name?: string;
    dob?: string;
    gender?: string;
    healthplanCode?: string;
    lineOfBusiness?: string;
    ipaCode?: string;
    patientId?: string;
    sourceId?: string;
    enrollmentDate?: string;
    address?: { state?: string | null } | null;
    /** Preferred SPOKEN language — what the interpreter rail wants. Free-text
     * vocabulary; normalize with `toBcp47()` before use. */
    languagePreferredSpoken?: string | null;
    /** General preferred language; fallback when the spoken one is unset. */
    languagePreferred?: string | null;
    memberIdOthers?: {
      mpi?: string;
      mbi?: string;
      apolloMemberKey?: string;
    };
  } | null;
}
